import React, { useState } from 'react';
import Icon from '../ui/Icon';

export default function ProfileSettingsModal({ isOpen, onClose, userProfile, onSave }) {
  const [formData, setFormData] = useState(userProfile);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-900">Profile Settings</h2>
          <button onClick={onClose} className="p-1 rounded-md hover:bg-gray-100 text-gray-500 transition-colors">
            <Icon name="close" size={20} color="currentColor" />
          </button>
        </div>
        
        <div className="p-6 overflow-y-auto">
          <div className="flex flex-col items-center mb-6">
            <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold text-3xl mb-3 overflow-hidden relative group cursor-pointer">
               {formData.avatar ? (
                 <img src={formData.avatar} alt="Avatar" className="w-full h-full object-cover" />
               ) : (
                 formData.name.charAt(0)
               )}
               <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                 <Icon name="edit" size={20} color="#fff" />
               </div>
            </div>
            <button className="text-sm text-blue-600 font-medium hover:text-blue-800">Change Avatar</button>
          </div>

          <div className="space-y-4 text-sm">
            <div>
              <label className="block text-gray-700 font-medium mb-1.5">Full Name</label>
              <input 
                type="text" 
                value={formData.name}
                onChange={e => setFormData({...formData, name: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1.5">Email Address</label>
              <input 
                type="email" 
                value={formData.email}
                onChange={e => setFormData({...formData, email: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1.5">Avatar URL (Optional)</label>
              <input 
                type="text" 
                value={formData.avatar || ''}
                onChange={e => setFormData({...formData, avatar: e.target.value})}
                placeholder="https://example.com/avatar.png"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
            </div>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
          <button 
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button 
            onClick={() => {
              onSave(formData);
              onClose();
            }}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}
